<div class="business-basic-details-root">
  <mat-card class="main-card">
    <div class="info-column">

      <div *ngIf="this.businessDisabled" class="disabled-message">
        <span [innerHTML]="this.labels.disabledBusinessMessage">
          {{ this.labels.disabledBusinessMessage }}
        </span>
        <span *ngIf="!this.global">
          {{ 'disabled-business-message-non-global' | transloco}}
        </span>
      </div>

      <div *ngIf="businessSummary?.businessType" class="business-type">
        {{ 'type-of-business-info' | transloco }}
        <span class="type">{{ businessSummary?.businessType }}</span>
      </div>

      <div class="business-contacts">
        <div class="contact-line filled-area">
          <mat-icon>
            pin_drop
          </mat-icon>
          <div class="address">
            {{ businessSummary?.addressNumber }}
            <span *ngIf="businessSummary?.addressNumber && businessSummary?.address"
              >,</span
            >
            {{ businessSummary?.address }} {{ businessSummary?.postalCode }}
          </div>
          <div class="country">
            - {{ businessSummary?.state }}
            <span *ngIf="businessSummary?.state && businessSummary?.country?.name"
              >, </span
            >{{ businessSummary?.country?.name }}
          </div>
        </div>
        
      </div>

      <div class="business-contacts">
        <div class="email filled-area">
          <mat-icon>
            email
          </mat-icon>
          <div>
            {{ businessSummary?.email }}  
          </div>
        </div>
        <div class="phone-number filled-area">
          <mat-icon>
            phone
          </mat-icon>
          <div>
            {{ businessSummary?.phoneNumber }}
          </div>
        </div>
      </div>

    </div>

    <div class="actions-column">
      <div>
        <app-icon-button 
          id="lnr-open-edit-business-modal-button" 
          v2 whiteBackground 
          borderless 
          icon="edit" 
          (clickAction)="openEditBusinessModal()"> 
          {{ 'edit-business-data' | transloco }} 
        </app-icon-button>
      </div>
    </div>

  </mat-card>

</div>
